export default __webpack_public_path__ + "static/logo-20a85cfa2cc2b3c3053c82af2fee5d3b.png";